module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/patrimony/patrimony.component.scss
// module id = ./src/app/limit-flow-proposal/component/patrimony/patrimony.component.scss
// module chunks = main